import React from "react";

import { TFunction } from "i18next";

import { BaseLabel, Button, Grid, GeneralPasswordInput } from "components";

import { StrongBar } from "components/StrongBar";
import { BarStrongLevelProps } from "components/StrongBar/interface";

import { TextForgotPasswordInfo } from "./styles";

export const ChangePasswordStepOne = (
  password: string,
  onChangePassword: (event: string) => void,
  confirmPassword: string,
  setConfirmPassword: React.Dispatch<React.SetStateAction<string>>,
  showPassword: [boolean, boolean],
  setShowPassword: React.Dispatch<React.SetStateAction<[boolean, boolean]>>,
  errors: boolean,
  statusPassword: BarStrongLevelProps["strongLevel"],

  handleSubmit: (e: any) => Promise<void>,
  t?: TFunction,
) => {
  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid alignContent="center">
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "390px",
            marginTop: "267px",
          }}
        >
          <TextForgotPasswordInfo>
            <BaseLabel
              fontSize="18px"
              fontWeight="700"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              marginRight="0px"
              children={
                t?.("auth.changePassword.createNew") ?? "Crie uma nova senha"
              }
            />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo paddingTop="28px">
            <BaseLabel
              fontSize="14px"
              fontWeight="500"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              marginRight="0px"
              children={
                t?.("auth.changePassword.passwordRules") ??
                "Utilize maiúsculas, minúsculas, números e um dos caracteres especiais (@ & $ % #) para criar uma senha forte."
              }
            />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo marginTop="-15px !important">
            <GeneralPasswordInput
              name="password"
              label={
                t?.("auth.changePassword.enterPassword") ?? "Digite a senha"
              }
              value={password}
              onChange={(e: string) => onChangePassword(e)}
              handleClickShowPassword={() =>
                setShowPassword([!showPassword[0], showPassword[1]])
              }
              showPassword={showPassword[0]}
              error={errors}
              marginLeft="0"
              height="51.5px"
              marginBottom="20px"
            />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo paddingTop="2px">
            <StrongBar strongLevel={statusPassword} />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo paddingTop="3px">
            <GeneralPasswordInput
              name="confirmPassword"
              label={
                t?.("auth.changePassword.repeatPassword") ?? "Repita a senha"
              }
              value={confirmPassword}
              onChange={setConfirmPassword}
              handleClickShowPassword={() =>
                setShowPassword([showPassword[0], !showPassword[1]])
              }
              showPassword={showPassword[1]}
              error={errors}
              marginLeft="0"
              height="51.5px"
              marginBottom="30px"
            />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo paddingTop="5px">
            <Button
              id="sign-in_button"
              type="submit"
              marginBottom="16px"
              backgroundColor="#1D9BF0"
              borderColor="#1D9BF0"
              textColor="white"
              backgroundHoverColor="#0D77BF"
              borderHoverColor="#0D77BF"
              onClick={(e: any) => {
                handleSubmit(e);
              }}
            >
              {t?.("common.continue") ?? "Continuar"}
            </Button>
          </TextForgotPasswordInfo>
        </Grid>
      </Grid>
    </form>
  );
};

export const ChangePasswordStepTwo = (
  navigate: any,
  navigateTo: string,
  t?: TFunction,
) => {
  return (
    <form>
      <Grid alignContent="center">
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "390px",
            marginTop: "315px",
          }}
        >
          <TextForgotPasswordInfo>
            <BaseLabel
              fontSize="14px"
              fontWeight="700"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              marginRight="0px"
              children={
                t?.("auth.changePassword.passwordChanged") ??
                "Sua senha foi alterada com sucesso!"
              }
            />
          </TextForgotPasswordInfo>
          <TextForgotPasswordInfo paddingTop="30px">
            <Button
              id="sign-in_button"
              type="submit"
              marginBottom="16px"
              backgroundColor="#1D9BF0"
              borderColor="#1D9BF0"
              textColor="white"
              backgroundHoverColor="#0D77BF"
              borderHoverColor="#0D77BF"
              onClick={() => navigate(navigateTo)}
            >
              {t?.("auth.backToLogin") ?? "Voltar ao login"}
            </Button>
          </TextForgotPasswordInfo>
        </Grid>
      </Grid>
    </form>
  );
};
